'use client'

// 禁用 IndexedDB 调试日志
if (typeof window !== 'undefined' && window.indexedDB) {
    // @ts-ignore
    window.indexedDB.debug = false;
}

import { storeUtils } from '@fanfanlo';
import AppContainer from "@src/components/app/AppContainer";
import { AppProps } from "next/app";
import { ErrorBoundary } from '@src/components/app/ErrorBoundary';
import { useEffect } from 'react';
import '../../globals.css';
import '../css/app.scss';

const s = storeUtils.namespace('test')

// 确保滚动条可见的组件
function EnsureScrollbarVisible() {
  useEffect(() => {
    // 确保 body 和 html 元素的 overflow 样式不会隐藏滚动条
    document.body.style.overflow = 'visible';
    document.documentElement.style.overflow = 'visible';
    
    // 监听全局错误事件
    const handleError = (event: ErrorEvent) => {
      // 确保错误后滚动条仍然可见
      document.body.style.overflow = 'visible';
      document.documentElement.style.overflow = 'visible';
      console.error('Global error caught:', event.error);
    };

    window.addEventListener('error', handleError);
    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []);

  return null;
}

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <ErrorBoundary>
      <EnsureScrollbarVisible />
      <AppContainer {...pageProps} Component={Component} />
    </ErrorBoundary>
  );
}

export default MyApp;
